import React from "react";
import { TbFileUpload } from "react-icons/tb";
import { MdInsertDriveFile } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const FileInput = ({ label, file, type, error, onChange, onRemove }) => {
  return (
    <div className="flex-1">
      <label className="block mb-2 text-[#FFFFFF] text-[16px] lg:text-[20px] font-lufga">
        {label}
      </label>

      {!file ? (
        <label
          htmlFor={type}
          className="flex items-center justify-center bg-[#2a2a2a] rounded-xl h-28 w-full md:w-[80%] cursor-pointer text-[14px] md:text-[18px]"
        >
          <div className="flex flex-row gap-2  items-center">
            <TbFileUpload className="text-gray-400 text-4xl mb-1" />
            <span className="text-gray-400 text-[16px] md:text-[20px]">
              Upload Image
            </span>
          </div>
          <input
            id={type}
            type="file"
            accept=".pdf,.jpeg,.jpg,.png"
            className="hidden"
            onChange={(e) => onChange(e, type)}
          />
        </label>
      ) : (
        <div className="bg-[#4a2e1a] rounded-xl h-28 w-full md:w-[80%] flex items-center justify-between px-8 overflow-hidden">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <MdInsertDriveFile className="text-orange-400 text-xl lg:text-2xl" />
            <p className="text-orange-300 text-sm lg:text-lg truncate whitespace-nowrap overflow-hidden max-w-full">
              {file.name}
            </p>
          </div>
          <button
            onClick={() => onRemove(type)}
            className="bg-white border-none text-black rounded-full w-8 h-8 flex items-center justify-center"
            type="button"
          >
            <IoClose className="w-5 h-5" />
          </button>
        </div>
      )}

      <p className="text-xs text-right pr-9 lg:pr-32 text-gray-500 mt-1">
        {type === "Civil ID Image"
          ? "File should be Pdf, JPEG and PNG"
          : "File size is 1mb"}
      </p>

      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

export default FileInput;
